import React from 'react'
import PropTypes from 'prop-types'
import { hooks } from '@adc/ui-adc'

const scrollToTop = () =>
  window.scrollTo({
    top: 0,
    left: 0,
    behavior: 'smooth',
  })

const AssetsPagination = ({ total, offset, limit, fetchAssets }) => {
  const onPageChange = ({ offset }) => {
    scrollToTop()
    fetchAssets({ offset })
  }

  const { PageSelection } = hooks.useOffsetPagination({
    pageSize: limit,
    totalCount: total,
    onPageChange,
    elmId: 'asset_inventory_pagination',
    initialOffset: offset,
  })

  if (!total) {
    return null
  }
  return (
    <div className='u-ta-r' style={{ textAlign: 'right' }}>
      {PageSelection}
    </div>
  )
}

AssetsPagination.propTypes = {
  total: PropTypes.number.isRequired,
  offset: PropTypes.number.isRequired,
  limit: PropTypes.number.isRequired,
  fetchAssets: PropTypes.func.isRequired,
}

export default AssetsPagination
